---
de:
  overview_map:
    homepage: Homepage
    nearest: nächstgelegene Kraftwerke
    news: Nachrichten
    nve_concession: NVE-Konzessionsnummer
